import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
  const location = useLocation();
  const adminToken = localStorage.getItem('adminToken');
  const adminUser = localStorage.getItem('adminUser');
  const userToken = localStorage.getItem('authToken');

  useEffect(() => {
    // Verify we're actually on an admin route
    if (!location.pathname.startsWith('/admin')) {
      return;
    }
    
    // Check if user token exists AND admin token exists (conflict situation)
    const currentUserToken = localStorage.getItem('authToken');
    const currentAdminToken = localStorage.getItem('adminToken');
    
    console.log('[AdminProtectedRoute] Token check:', {
      hasAdminToken: !!currentAdminToken,
      hasUser: !!adminUser,
      hasUserToken: !!currentUserToken,
      path: location.pathname
    });
    
    // Only clear user token if BOTH tokens exist (conflict)
    // Don't clear if only user token exists (user might be transitioning)
    if (currentUserToken && currentAdminToken) {
      console.warn('[AdminProtectedRoute] CONFLICT: Both tokens exist on admin route - clearing user token');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
    }
  }, []); // Run only once on mount

  // If no admin token, redirect to admin login (NOT candidate auth)
  if (!adminToken) {
    console.warn('[AdminProtectedRoute] No admin token found, redirecting to admin login');
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // If token exists, allow access
  console.log('[AdminProtectedRoute] Access granted');
  return children;
};

export default AdminProtectedRoute;
